import React from 'react';
import { FaTimes,  } from 'react-icons/fa';
import { Button, Jumbotron, Container, Figure} from 'react-bootstrap';
import { useScreen } from '@putil-view/use.use-screen';
import PropTypes from 'prop-types';
export const ConfirmForm = ({state, setState, onRestart})=>{
	const screen = useScreen();
	const obj = {
		'Locker Apperance Image' : state.lockerImage,
		'Locker Items Image': state.lockerItems,
		'Locker Video':state.lockerVideoUrl
	}
	const previewFileStyle = {
		height: screen.isWideScreen ?'50vh':'45vh',
		width:  screen.isWideScreen ?'50vh':'100%',
		display:'flex',
		justifyContent: 'center',
		objectFit: 'cover'
	};
	return (
		<Jumbotron fluid>
			<Container>
				<h1 className="display-5 text-center">Are you confirm to upload below images and video as unlock record for {state.scanText}?</h1>
				<div className="text-center">
					<br/>
					
					<Button block variant="outline-secondary" className="text-center"
						onClick={onRestart}>
						<FaTimes/>Cancel
					</Button>
					<Button block variant="success" className="text-center"
						onClick={()=>{
							setState(prevState =>{
								return{...prevState , ...{stage: "UPLOAD_UNLOCK_DATA"}};
							})
						}}>
						Confirm
					</Button>
					<br/>
				</div>
				<div className="text-center">
					{['Locker Apperance Image', 'Locker Items Image'].map(prop => {
						return (
						<>
						<Figure>
							<Figure.Image 
								style={previewFileStyle}
								src={obj[prop]}
							/>
						</Figure>
						<br/>
						</>
						)
					})}
					{obj['Locker Video'] && 
						<Figure>
						<div className="d-flex justify-content-center ">
						<video style={previewFileStyle} controls>
						<source src={obj['Locker Video']}/>
						</video>
						</div>
						</Figure>
					}
				</div>
			</Container>
		</Jumbotron>
	)
}
ConfirmForm.propTypes = {
	state: PropTypes.object,
	setState: PropTypes.func,
	onRestart: PropTypes.func,
};
